function calculateStepPricing (items, stepPricing) {
// SPP40POS
// SPP30POS
// SPP20POS
  let unsaleItems = []
  let saleItems = []
  let allItems = []
  const discount70p = []
  const discount50p = []
  const discount40p = []
  const discount30p = ['myarisweb', 'myarispos']
  const discount20p = []
  const discount85pFloor = ['gel']
  const discount70pFloor = []
  const discount50pFloor = ['sanitizer']
  const discount30pFloor = []
  const discount400 = []
  for (let item of items) {
    const isTag = item.tags && item.tags.length > 0
    let isDiscount70p = isTag && discount70p.length > 0 ? item.tags.some(tag => discount70p.some(dis => dis === tag)) : false
    let isDiscount50p = isTag && discount50p.length > 0 ? item.tags.some(tag => discount50p.some(dis => dis === tag)) : false
    let isDiscount85pFloor = isTag && discount85pFloor.length > 0 ? item.tags.some(tag => discount85pFloor.some(dis => dis === tag)) : false
    let isDiscount70pFloor = isTag && discount70pFloor.length > 0 ? item.tags.some(tag => discount70pFloor.some(dis => dis === tag)) : false
    let isDiscount50pFloor = isTag && discount50pFloor.length > 0 ? item.tags.some(tag => discount50pFloor.some(dis => dis === tag)) : false
    let isDiscount30pFloor = isTag && discount30pFloor.length > 0 ? item.tags.some(tag => discount30pFloor.some(dis => dis === tag)) : false
    let isDiscount40p = isTag && discount40p.length > 0 ? item.tags.some(tag => discount40p.some(dis => dis === tag)) : false
    let isDiscount30p = isTag && discount30p.length > 0 ? item.tags.some(tag => discount30p.some(dis => dis === tag)) : false
    let isDiscount20p = isTag && discount20p.length > 0 ? item.tags.some(tag => discount20p.some(dis => dis === tag)) : false
    let isDiscount400 = isTag && discount400.length > 0 ? item.tags.some(tag => discount400.some(dis => dis === tag)) : false
    if (isDiscount70p) {
      item.priceDiscount = Math.round(parseInt(item.price) * 0.3)
      saleItems.push(item)
    } else if (isDiscount50p) {
      item.priceDiscount = Math.round(parseInt(item.price) * 0.5)
      saleItems.push(item)
    } else if (isDiscount85pFloor) {
      item.priceDiscount = Math.floor(parseInt(item.price) * 0.15)
      saleItems.push(item)
    } else if (isDiscount70pFloor) {
      item.priceDiscount = Math.floor(parseInt(item.price) * 0.3)
      saleItems.push(item)
    } else if (isDiscount50pFloor) {
      item.priceDiscount = Math.floor(parseInt(item.price) * 0.5)
      saleItems.push(item)
    } else if (isDiscount30pFloor) {
      item.priceDiscount = Math.floor(parseInt(item.price) * 0.7)
      saleItems.push(item)
    } else if (isDiscount40p) {
      item.priceDiscount = Math.round(parseInt(item.price) * 0.6)
      saleItems.push(item)
    } else if (isDiscount30p) {
      item.priceDiscount = Math.round(parseInt(item.price) * 0.7)
      saleItems.push(item)
    } else if (isDiscount20p) {
      item.priceDiscount = Math.round(parseInt(item.price) * 0.8)
      saleItems.push(item)
    } else if (isDiscount400) {
      item.priceDiscount = parseInt(item.price) - 400
      saleItems.push(item)
    } else {
      item.priceDiscount = parseInt(item.price)
      unsaleItems.push(item)
    }
  }

  unsaleItems = unsaleItems.sort((a, b) => (parseInt(b.priceDiscount) - parseInt(a.priceDiscount)))
  allItems = unsaleItems.concat(saleItems)
  let result = []
  let itemInTier5 = (allItems.length / 5 | 0) * 5
  let itemInTier3 = ((allItems.length - itemInTier5) / 3 | 0) * 3

  allItems.forEach((item, i) => {
    let price = parseInt(item.priceDiscount)
    if (i >= 0 && i < itemInTier5) {
      result.push({
        ...allItems[i],
        priceDiscount: stepPricing[price] ? stepPricing[price]['tier5'] : price
      })
    } else if (i >= itemInTier5 && (i < itemInTier5 + itemInTier3)) {
      result.push({
        ...allItems[i],
        priceDiscount: stepPricing[price] ? stepPricing[price]['tier3'] : price
      })
    } else {
      result.push({
        ...allItems[i],
        priceDiscount: stepPricing[price] ? stepPricing[price]['tier1'] : price
      })
    }
  })
  return result
}

export {
  calculateStepPricing
}



// WEBPACK FOOTER //
// ./src/utils/modules/cart.js